/**
 * React Query hooks for the global EULA editor. Fetcher lives in
 * `@/api/eula`; this wires caching + a success toast consistent with the
 * rest of the admin console. On save we seed the cache with the returned
 * value so the editor reflects the persisted EULA without a refetch.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { getEula, updateEula } from '@/api/eula';

export function useEula() {
  return useQuery({ queryKey: ['eula'], queryFn: getEula });
}

export function useUpdateEula() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (html: string) => updateEula(html),
    onSuccess: data => {
      qc.setQueryData(['eula'], data);
      toast.success('EULA updated');
    },
    onError: (err: unknown) => {
      const msg = (err as { response?: { data?: { errors?: { msg?: string } } } })
        ?.response?.data?.errors?.msg;
      toast.error(msg || 'Update failed — try again.');
    }
  });
}
